let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gaien")).then(() => parcelRequire('btTZq'));